import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Select from '../Select'

const items = [{
  value: 'BB',
  label: 'Bollinger Bands'
}, {
  value: 'MACD',
  label: 'MACD'
}, {
  value: 'RSI',
  label: 'RSI'
}, {
  value: 'MA',
  label: 'MA'
}, {
  value: 'EMA',
  label: 'EMA'
}, {
  value: 'ATR',
  label: 'ATR'
}, {
  value: 'OBV',
  label: 'OBV'
}, {
  value: '52_WEEK_HIGH',
  label: '52 week high'
}, {
  value: '52_WEEK_LOW',
  label: '52 week low'
}]

@inject('store') @observer
class Technical extends Component {
  handleChange = (e) => {
    const {analysis} = this.props.store
    const value = e.target.getAttribute('value')
    if (analysis.technical.find(ind => ind.ident === value) && value !== 'MA' && value !== 'EMA') {
      analysis.removeIndicator('technical', value)
    } else {
      analysis.addIndicator('technical', value)
    }
  }
  render() {
    const {technical} = this.props.store.analysis
    let selected = []
    let loadingItems = []
    technical.map(ind => {
      selected.push(ind.ident)
      if (ind.loading) {
        loadingItems.push(ind.ident)
      }
    })
    return(
      <Select
        label='Technical'
        onSelect={this.handleChange}
        items={items}
        selected={selected}
        loadingItems={loadingItems}
      />
    )
  }
}

export default Technical
